import { http } from '../../config/axios'

export default function putNotificacaoFatura(notificacaoFatura: any): Promise<string> {
  return http
    .put('api/notificacao-fatura', notificacaoFatura)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro put notificacaoFatura', error)
      throw Error(error.response.data)
    })
}
